import { render, staticRenderFns } from "./BatchPreview.vue?vue&type=template&id=71ddea31&"
import script from "./BatchPreview.vue?vue&type=script&lang=js&"
export * from "./BatchPreview.vue?vue&type=script&lang=js&"
import style0 from "./BatchPreview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BatchPreview.vue"
export default component.exports